<template>
  <div>
    <label
      class="font-weight-bold main-label mb-3"
      :class="[{ 'input-custom error': v.$error }]"
      ><slot name="label-title"></slot>
    </label>
    <div class="panel-upload">
      <div class="panel-upload-box upload-mobile" v-if="!isMaxImg">
        <div class="panel-bg-file-img mb-2" for="file_upload">
          <font-awesome-icon icon="plus" color="#FFB300" class="icon-add" />
          <input
            type="file"
            name="name"
            ref="input"
            accept="image/png, image/jpeg"
            id="file_upload"
            v-on:change="onFileChange"
            :disabled="isDisabled"
          />
        </div>
      </div>

      <draggable
        :list="imageList"
        class="d-flex flex-wrap px-md-10 upload-mobile"
      >
        <div
          class="panel-wrap-bg-file-img d-flex"
          v-for="(item, index) in imageList"
          :key="index"
        >
          <div
            class="panel-bg-file-img mb-2"
            v-bind:style="{ backgroundImage: 'url(' + item.imageUrl + ')' }"
          >
            <font-awesome-icon
              icon="times-circle"
              color="#979797"
              class="icon-delete pointer"
              @click="deleteImage(index, item.productImageId)"
            />
            <font-awesome-icon
              icon="eye"
              :class="{
                'icon-eye-show pointer': item.display,
                'icon-eye-hide pointer': !item.display,
              }"
              @click="hideImage(index, item.display)"
            />
          </div>
        </div>
      </draggable>
    </div>

    <div v-if="v && v.$error">
      <span class="text-error f-size-14" v-if="v.required == false">
        กรุณาอัพโหลดรูปภาพอย่างน้อย 1 รูปภาพ
      </span>
    </div>
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
  </div>
</template>

<script>
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import draggable from "vuedraggable";

export default {
  name: "ProductImage",
  components: {
    ModalAlertError,
    draggable,
  },
  props: {
    dataList: {
      required: false,
      type: Array,
    },
    v: {
      required: false,
      type: Object,
    },
    productIndex: {
      required: false,
      type: Number,
    },
  },
  data() {
    return {
      file: "",
      value: "",
      type: {
        all: ["image/jpeg", "image/png", "application/pdf", ""],
        file: ["image/jpeg", "image/png", "application/pdf"],
        image: ["image/jpeg", "image/png"],
      },
      modalMessage: "",
      image: "",
      filename: "",
      images: "",
      imageList: this.dataList,
      dragging: false,
    };
  },
  computed: {
    draggingInfo() {
      return this.dragging ? "under drag" : "";
    },
    isMaxImg() {
      if (this.imageList != null) return this.imageList.length == 8;
      else return null;
    },
    isDisabled() {
      return this.dataList.length >= 8;
    },
  },
  methods: {
    onFileChange(e) {
      // this.errorFile = "";
      const file = e.target.files[0];
      this.filename = file.name;
      var _validFileExtensions = ["image/jpeg", "image/png"];
      if (e.target.files.length) {
        if (_validFileExtensions.indexOf(file.type) < 0) {
          this.$refs.input.value = "";
          this.modalMessage = `This file is not supported`;
          this.$refs.modalAlertError.show();
        }
        if (file.size > 10000000) {
          this.modalMessage = `This file is too large `;
          this.$refs.modalAlertError.show();
          this.$refs.input.value = "";
          return;
        } else {
          this.$refs.input.value = "";
          this.handleChangeFileImage(file);
        }
      } else {
        this.$refs.input.value = "";
      }
    },
    handleChangeFileImage: async function (value) {
      if (value) {
        var reader = new FileReader();
        const objectURL = URL.createObjectURL(value);
        reader.readAsDataURL(value);
        reader.onload = async () => {
          this.images = objectURL;
          await this.saveImage(this.images, reader.result);
        };
      } else {
        this.value = "";
      }
    },
    saveImage: async function (value, base64) {
      if (value) {
        this.imageList.push({
          imageUrl: value,
          sortOrder: 0,
          base64: base64,
          display: false,
          translation: [
            {
              languageId: 1,
              altTag: this.filename,
            },
            {
              languageId: 2,
              altTag: this.filename,
            },
          ],
        });

        this.$emit("updateImageList", this.imageList, this.productIndex);
      }
    },

    saveImagetoDb: async function (img) {
      var imgData = {
        Base64: img,
      };

      return new Promise((resolve, reject) => {
        this.axios
          .post(`${this.$baseUrl}/product/SaveImage`, imgData)
          .then((data) => {
            if (data.result == 1) {
              resolve(data.detail.url);
            } else {
              reject(data);
            }
          });
      });
    },
    deleteImage(index, imageId) {
      const data = {
        value: true,
        imageId,
      };
      if (this.$refs.input) {
        this.$refs.input.value = "";
      }
      this.imageList.splice(index, 1);
      this.$emit("deleteImageOption", data, this.imageList, this.productIndex);
    },
    hideImage(index, display) {
      this.imageList[index].display = !display;
      this.$emit("displayImage", this.imageList, this.productIndex);
    },
  },
};
</script>

<style scoped>
.panel-upload {
  position: relative;
  margin-bottom: 15px;
  display: flex;
  flex-direction: row;
}

.panel-upload-box {
  max-width: 153px;
  padding-right: 15px;
  width: 100%;
}

.panel-upload-box-list {
  max-width: 153px;
  padding-right: 15px;
  padding-left: 15px;
  width: 100%;
}

.panel-wrap-bg-file-img {
  width: 150px;
  height: 150px;
  padding-right: 15px;
}

.panel-bg-file-img {
  position: relative;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  padding-bottom: 100%;
  border: 2px dashed #979797;
  width: 100%;
  cursor: move;
}

input[type=file], /* FF, IE7+, chrome (except button) */
input[type=file]::-webkit-file-upload-button {
  /* chromes and blink button */
  cursor: pointer;
  width: 100%;
  height: 100%;
  line-height: 95px;
  position: absolute;
  opacity: 0;
}

.icon-add {
  position: absolute;
  top: 50%;
  left: 50%;
  -moz-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  width: 25px;
  height: 25px;
  color: #8f20c6;
}

.icon-delete {
  position: absolute;
  right: 1px;
  top: 1px;
  color: #707070;
}
.icon-eye-show {
  position: absolute;
  left: 1px;
  bottom: 1px;
  color: #ffb300;
}
.icon-eye-hide {
  position: absolute;
  left: 1px;
  bottom: 1px;
  color: #707070;
}

.text-error {
  color: red;
}

@media (max-width: 767.98px) {
  .panel-upload-box,
  .panel-wrap-bg-file-img {
    max-width: 33.33%;
  }
  .panel-wrap-bg-file-img {
    padding-right: 5px;
    padding-left: 5px;
  }
}

@media (max-width: 600px) {
  .panel-upload-box {
    max-width: calc(100% / 3);
  }
}

@media (max-width: 400px) {
  .panel-upload {
    flex-direction: column;
  }
}
</style>
